export default __webpack_public_path__ + "static/media/illustration_china-data.aa408131.png";